import type { GetApiV1ThreeLetterCodeClientAdminsClient200 } from '@fukuri-admins/apis/client/gen/model';
import type { EditFormFieldValues } from '../editFormSchema';

type IConvertToFormValues = (
  data: GetApiV1ThreeLetterCodeClientAdminsClient200
) => EditFormFieldValues;

/**
 * API レスポンスを送付先住所編集フォームの初期値に変換する
 *
 * - shipping_address が未登録（null）の場合は住所系フィールドを空文字で初期化する
 * - prefecture.code（2桁コード文字列）を prefectureCode にそのまま保持する（Select の value）
 * - employeeCount はテキスト入力の値として文字列で保持する。employee_count が null のときは
 *   `'0'` を補完すると「利用人数が実際に0人」と区別が付かなくなるため空文字にする
 */
export const convertToFormValues: IConvertToFormValues = ({ client }) => ({
  employeeCount: client.employee_count == null ? '' : String(client.employee_count),
  postalCode: client.shipping_address?.postal_code ?? '',
  prefectureCode: client.shipping_address?.prefecture?.code ?? '',
  city: client.shipping_address?.city ?? '',
  streetAddress: client.shipping_address?.street_address ?? '',
});
